export default "__VITE_ASSET__jEnMfZyK__"